module.exports = __webpack_public_path__ + "img/eoi-docusign.fc983c09.png";